export default "__VITE_ASSET__CjIwXx7y__"